// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"569e4607","227":"98158728","258":"a4731f95","453":"258b012d","500":"657f5224","648":"efa746be","961":"c8ef8aee","997":"02769c87"}[chunkId] + ".chunk.js";
};